import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
} from 'react-intl';
import { IOrderDetails } from '../../../models/order';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import OrderNotification from '../../common/order-notification';
import moment from 'moment';
import { IITAPISResult } from '../../../models/result-models';

interface INotificationDashboard {
    order: IOrderDetails;
    cancelOrderResult: IITAPISResult | null | undefined;
}

const NotificationDashboard = ({
    order,
    cancelOrderResult,
}: INotificationDashboard) => {
    return (
        <>
            {order.holds && order.oracleOrderStatus !== 'Closed' && (
                <>
                    {order.holds.map((hold, i) => {
                        if (hold.name === 'ORDER CANCELLED FROM ESTORE') {
                            return (
                                <OrderNotification
                                    key={hold.name}
                                    className="alert-order"
                                >
                                    <>
                                        <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                        <FormattedMessage
                                            id="Cancellation_Request"
                                            defaultMessage="A cancellation request is currently
                                        pending on this order. We will notify
                                        you once complete and status will update
                                        at that time."
                                        />
                                    </>
                                </OrderNotification>
                            );
                        } else {
                            return <React.Fragment key={i}></React.Fragment>;
                        }
                    })}
                </>
            )}
            {/*logic to handle if there is an error with cancel order on front end */}
            {cancelOrderResult !== null && cancelOrderResult !== undefined && (
                <>
                    {cancelOrderResult.responseStatus.errorCode === 'E' && (
                        <OrderNotification className="alert-order">
                            <>
                                <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                <FormattedMessage
                                    id="Cancellation_Error"
                                    defaultMessage="There was an error cancelling your order, please
                                try again later."
                                />
                            </>
                        </OrderNotification>
                    )}
                </>
            )}

            <>
                {order.orderEscalateDate && (
                    <OrderNotification className="alert-order">
                        <>
                            <span className="fa fa-exclamation-triangle cancel-icon"></span>
                            <FormattedMessage
                                id="Escalated_Message"
                                defaultMessage="This order was reported as lost or damaged and was
                            escalated to Customer Service on"
                            />

                            {' ' +
                                moment(order.orderEscalateDate).format(
                                    'MMM DD, YYYY'
                                )}
                        </>
                    </OrderNotification>
                )}
            </>
        </>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        cancelOrderResult: state.cancelOrderResult
            ? state.cancelOrderResult!.data
            : null,
    };
};

const mapDispatchToProps = {};

const NotificationDashboardContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationDashboard);

export default NotificationDashboardContainer;
